
export default {
	props: {
		textInfo: {
			type: String,
			default: '',
		},
	},
};
